import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";

import useCheckoutPageProps from "@hooks/useCheckoutPageProps";

import checkoutRouter from "@routers/checkoutRouter";
import { useAtom, useSetAtom } from "jotai";

import { checkoutAtom, parentIdAtom } from "@atoms/checkoutAtom.ts";

import { dispatchGAEvents } from "@utils/events/dispatchGAEvents";

const Checkout = () => {
    const { parentUser } = useCheckoutPageProps();

    const setCheckout = useSetAtom(checkoutAtom);

    const [parentId] = useAtom(parentIdAtom);

    const handleLogoClick = () => {
        dispatchGAEvents({
            event: "drop_off",
            eventCategory: "checkout",
            eventAction: "existing_user",
            eventLabel: "Logo click",
            parentId
        });
    };

    useEffect(() => {
        const logoLink = document.getElementById("euka-logo-link");
        if (logoLink) {
            logoLink.addEventListener("click", handleLogoClick);
        }

        return () => {
            if (logoLink) {
                logoLink.removeEventListener("click", handleLogoClick);
            }
        };
    }, []);

    /**
     * If a parent is logged into the portal, we pre-initialize the user info for the chekout portal
     * based on the logged in parent's data
     */
    if (parentUser) {
        setCheckout(prev => ({
            ...prev,
            user: {
                firstName: parentUser.firstName,
                email: parentUser.email,
                receiveOfferNews: true
            }
        }));
    }

    return <RouterProvider router={checkoutRouter} />;
};

export default Checkout;
